import { cn } from "@/lib/utils";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_5347f093-7f09-4e2e-8ae3-688273f8e365/artifacts/2c4spw9p_VERTICAL%20CLARA.png";

export const Logo = ({ className, height = 56, dark = true, bare = false }) => {
  // bare=true → render the image directly without wrapper box (use when parent already has dark bg)
  if (bare) {
    return (
      <img
        src={LOGO_URL}
        alt="CEAP Brasil & Lopes"
        style={{ height, width: "auto", objectFit: "contain" }}
        className={cn("block select-none self-start flex-shrink-0", className)}
        data-testid="ceap-logo"
      />
    );
  }
  // Default: dark chip background (white logo on dark)
  const wrapperClass = dark
    ? "inline-flex items-center justify-center bg-ink rounded-md px-4 py-3 self-start"
    : "inline-flex items-center justify-center bg-ink rounded-md px-3 py-2 self-start";
  return (
    <div className={cn(wrapperClass, className)} data-testid="ceap-logo">
      <img
        src={LOGO_URL}
        alt="CEAP Brasil & Lopes"
        style={{ height, width: "auto", objectFit: "contain" }}
        className="block select-none"
      />
    </div>
  );
};

export const LogoMark = ({ className }) => (
  <div
    className={cn(
      "inline-flex items-center justify-center bg-ink text-white font-semibold rounded-md w-9 h-9",
      className,
    )}
  >
    CB
  </div>
);
